/**
 * Returns validation errors for a given field as an array.
 */
export const useFieldErrors = (props) => {
    const errorsFor = (field) => {
        if (props.errors && typeof props.errors === 'object' && !Array.isArray(props.errors)) {
            const error = props.errors[field];
            return Array.isArray(error) ? error : [];
        }
        return [];
    };
    return { errorsFor };
};
